import { GET_PURCHASE_RECEIPTS } from "../../type/purchaseReceipts";
// **  Initial State
const initialState = {
  data: [],
  totalRecords: 0,
  totalPages: 1,
  percentage: 0,
  params: {},
};

const pricesReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PURCHASE_RECEIPTS:
      return {
        ...state,
        data: action.payload.results,
        totalPages: action.payload.totalPages,
        totalRecords: action.payload.totalResults,
        params: { limit: action.payload.limit, page: action.payload.page },
      };
    default:
      return state;
  }
};

export default pricesReducer;
